import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getChapterOptions } from '@/module/Author/Chapter';
import { ChapterEdit } from '@/module/Author/Chapter/ChapterEdit';

export const Route = createFileRoute('/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { chapterId } = Route.useParams();
  const { data: chapter } = useSuspenseQuery(getChapterOptions(chapterId));

  return <ChapterEdit chapter={chapter} />;
}
